import React, { useMemo } from "react";
import { WSSelect } from "../WSSelect/WSSelect";
import {
  FilterChangeHandler,
  WSFilterSelect,
  WSFilterSingleValue
} from "./types";

type Props = {
  value?: WSFilterSingleValue;
  onChange: FilterChangeHandler;
} & Omit<WSFilterSelect, "type">;

export const FilterFieldSelect: React.FC<Props> = ({
  name,
  options,
  value: uncastedValue,
  onChange
}) => {
  const value = useMemo(() => (uncastedValue ? uncastedValue : null), [
    uncastedValue
  ]);

  return (
    <WSSelect
      value={value}
      onChange={(newValue) => {
        onChange(name, newValue || undefined);
      }}
      options={options.map((option) => ({
        label: option.label,
        labels: option.helperText ? [option.helperText] : undefined,
        value: option.name
      }))}
    />
  );
};
